import React from 'react';
import { useNavigate } from 'react-router-dom';

const BRAND_STATEMENT = 'ज्योतिषं वेदस्य चक्षु: सत्यं ज्ञानं अनन्तं ब्रह्म ॥';

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="border-t border-canvas/10 bg-ground-deep text-canvas">
      <div className="mx-auto max-w-container px-5 py-16 sm:px-8 lg:px-10">
        <div className="grid gap-12 lg:grid-cols-[1.3fr_1fr_1fr]">
          <div>
            <h3 className="font-serif text-2xl italic text-canvas">Bhavishyavani</h3>
            <p className="mt-3 max-w-sm text-sm leading-6 text-canvas/60">
              Private, focused astrology guidance for love, career, and life's turning points &mdash; one
              question at a time.
            </p>
            <p className="mt-5 max-w-sm font-serif text-base italic leading-7 text-brand-accent">
              {BRAND_STATEMENT}
            </p>
          </div>

          <div>
            <h4 className="text-[11px] font-medium uppercase tracking-[0.22em] text-canvas/45">Explore</h4>
            <ul className="mt-5 space-y-3 text-sm">
              <li><button type="button" className="text-canvas/75 transition hover:text-canvas" onClick={() => navigate('/')}>Home</button></li>
              <li><button type="button" className="text-canvas/75 transition hover:text-canvas" onClick={() => navigate('/book')}>Book Session</button></li>
              <li><button type="button" className="text-canvas/75 transition hover:text-canvas" onClick={() => navigate('/services')}>Services</button></li>
              <li><button type="button" className="text-canvas/75 transition hover:text-canvas" onClick={() => navigate('/blog')}>Blog</button></li>
              <li><button type="button" className="text-canvas/75 transition hover:text-canvas" onClick={() => navigate('/contactUs')}>Contact</button></li>
            </ul>
          </div>

          <div>
            <h4 className="text-[11px] font-medium uppercase tracking-[0.22em] text-canvas/45">Company</h4>
            <ul className="mt-5 space-y-3 text-sm">
              <li><button type="button" className="text-canvas/75 transition hover:text-canvas" onClick={() => navigate('/terms-and-conditions')}>Terms and Conditions</button></li>
              <li><button type="button" className="text-canvas/75 transition hover:text-canvas" onClick={() => navigate('/privacy-policy')}>Privacy Policy</button></li>
              <li><button type="button" className="text-canvas/75 transition hover:text-canvas" onClick={() => navigate('/cancellation-refund-policy')}>Cancellation and Refund</button></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-2 border-t border-canvas/10 pt-6 text-xs text-canvas/45 sm:flex-row sm:items-center sm:justify-between">
          <p>&copy; Bhavishyavani {new Date().getFullYear()}</p>
          <p>Private online astrology sessions</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
